const Facebook = ({ color = 'black', variant = 'filled', strokeWidth = 1  }) => {
    if (variant === 'outlined') {
        return (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="transparent" xmlns="http://www.w3.org/2000/svg">
                <circle stroke-width={strokeWidth} cx="16.1247" cy="16.125" r="12.5" stroke={color}/>
                <path stroke-width={strokeWidth} d="M14.1657 19.17V28.9531H18.1032V19.17H20.947L21.6345 15.4825H18.1032V13.17C18.1032 11.545 19.572 11.2637 20.1657 11.2637H21.6345V8.2325L19.1657 8.04499C14.572 7.85749 14.1657 11.795 14.1657 12.67V15.4825H11.072V19.17H14.1657Z" fill={color}/>
            </svg>

        );
    }

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="transparent" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3847 28.9754C24.6254 28.0225 29.4062 22.632 29.4062 16.125C29.4062 8.9453 23.5859 3.125 16.4062 3.125C9.22646 3.125 3.40616 8.9453 3.40616 16.125C3.40616 22.6388 8.19694 28.0337 14.4472 28.9784V19.17H11.3535V15.4825H14.4472V12.67C14.4472 11.795 14.8535 7.85749 19.4472 8.04499L21.916 8.2325V11.2637H20.4472C19.8535 11.2637 18.3847 11.545 18.3847 13.17V15.4825H21.916L21.2285 19.17H18.3847V28.9754Z" fill={color}/>
        </svg>

    )

}

export default Facebook;
